import React, { PropTypes } from 'react';
import { ImageCard, Card } from '../';

const CardContainer = ({ items = [], title, iconUrl, alt, link, linkText, isNews = false }) => (
  <div className="container">
    <div className="row">
      <div className="col-sm-12">
        <header className="section-header">
          <h2>
            <img src={iconUrl} alt={alt} />
          </h2>
          <h1>{title}</h1>
        </header>
      </div>
    </div>
    <div className="row">
      <div className="col-sm-12">
        <div className="box-grid-module">
          <ul className="box-grid">
            {items.map((item, index) => {
              if (index === 0 || items.length < 4) {
                return (
                  <ImageCard
                    key={index}
                    link={item.link}
                    title={item.title}
                    fullDate={item.fullDate}
                    description={item.description}
                    thumbnail={item.thumbnail}
                    isNews={isNews}
                  />
                );
              }
              return index < 4
                ? <Card key={index} link={item.link} title={item.title} fullDate={item.fullDate} />
                : null;
            })}
          </ul>
        </div>
      </div>
    </div>
    {items.length > 4
      ? <div className="row">
          <div className="col-sm-12">
            <span>
              <a className="see-all-link" href={link}>
                {linkText}
                <i className="icon icon-budicon-461" aria-hidden="true" />
              </a>
            </span>
          </div>
        </div>
      : null}
  </div>
);

CardContainer.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      link: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      fullDate: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      thumbnail: PropTypes.string.isRequired
    })
  ),
  title: PropTypes.string.isRequired,
  iconUrl: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
  linkText: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  isNews: PropTypes.bool
};

export default CardContainer;



// WEBPACK FOOTER //
// ./src/pages/press/components/CardContainer/CardContainer.js